export default __webpack_public_path__ + "static/media/up.aba5b6af.svg";